import { TableTotalsFooter } from "../../components/DataTable/TableTotals"
import { useTranslation } from "react-i18next"

import { formatNumber } from "../../utilities/format"

type RehandleGroupsTableFooterProps = {
  totalLoads?: number
  totalTonnes?: number
  isLoading: boolean
}

const RehandleGroupsTableFooter: React.FC<RehandleGroupsTableFooterProps> = ({
  totalLoads,
  totalTonnes,
  isLoading
}) => {
  const { t } = useTranslation("geology");
  return (
    <TableTotalsFooter
      isLoading={isLoading}
      totals={[
        { label: t("totals.loads"), value: formatNumber(totalLoads) },
        { label: t("totals.tonnes"), value: totalTonnes != null ? formatNumber(Math.round(totalTonnes)) : '' }
      ]}
    />
  )
}

export default RehandleGroupsTableFooter
